import { useState, useEffect } from 'react';
import eventBus from "EventBus";
import constants from 'Constants';
import listService from 'ListService';
import mobileService from '../../../../service/mobile/MobileService';
/**
 * A custom hook to determine if the mobile icon badge should be shown.
 * The badge indicates that the desktop form has changes not yet reflected in the mobile version.
 */
export const useMobileStatus = () => {
  const [needsUpdate, setNeedsUpdate] = useState(false);



  useEffect(() => {
    const validate = () => {
      const wizardCompleted = listService.mobileGetWizardCompleted;
      const hasNewObjects = mobileService.designerHasNewObjects();
            
      setNeedsUpdate(wizardCompleted && hasNewObjects);
    };

    validate();

    // this event is triggered whenever a control is added or removed
    eventBus.on(constants.EV_VALIDATE_PULSE_ICON_EVENT, validate);
    return () => {
      eventBus.off(constants.EV_VALIDATE_PULSE_ICON_EVENT, validate);
    };
  }, []);

  return { needsUpdate };
};